import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { ImageIcon, Mic, Youtube, FileText } from 'lucide-react';

export const RecognitionHubPage: FC = () => {
  const { t } = useTranslation();

  const TOOLS = [
    {
      href: '/photo-to-text/',
      icon: ImageIcon,
      color: 'text-blue-500',
      bg: 'bg-blue-50',
      title: t('recognitionPage.photoCard'),
      description: t('recognitionPage.photoCardDesc'),
    },
    {
      href: '/audio-to-text/',
      icon: Mic,
      color: 'text-purple-500',
      bg: 'bg-purple-50',
      title: t('recognitionPage.audioCard'),
      description: t('recognitionPage.audioCardDesc'),
    },
    {
      href: '/youtube-to-text/',
      icon: Youtube,
      color: 'text-red-500',
      bg: 'bg-red-50',
      title: t('recognitionPage.youtubeCard'),
      description: t('recognitionPage.youtubeCardDesc'),
    },
    {
      href: '/pdf-to-text/',
      icon: FileText,
      color: 'text-orange-500',
      bg: 'bg-orange-50',
      title: t('recognitionPage.documentCard'),
      description: t('recognitionPage.documentCardDesc'),
    },
  ];

  return (
    <>
      <Helmet>
        <title>Распознавание текста онлайн — фото, аудио, PDF, YouTube | Писака</title>
        <meta name="description" content="Бесплатные инструменты распознавания текста онлайн: фото в текст, аудио в текст, YouTube видео в текст, PDF в текст. Выберите нужный инструмент." />
        <link rel="canonical" href="https://pisaka.online/recognize/" />
      </Helmet>

      <div className="min-h-screen bg-white pt-60 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-3xl font-bold text-gray-900 mb-3">{t('recognitionPage.hubTitle')}</h1>
            <p className="text-gray-500 text-base max-w-xl mx-auto">{t('recognitionPage.hubDescription')}</p>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {TOOLS.map(({ href, icon: Icon, color, bg, title, description }) => (
              <a
                key={href}
                href={href}
                className="bg-white rounded-2xl border border-gray-200 p-6 hover:border-gray-300 hover:shadow-sm transition-all flex gap-4"
              >
                <div className={`${bg} rounded-xl p-3 flex-shrink-0 self-start`}>
                  <Icon className={`w-6 h-6 ${color}`} />
                </div>
                <div>
                  <h2 className="font-semibold text-gray-900 mb-1">{title}</h2>
                  <p className="text-sm text-gray-500 leading-relaxed">{description}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
